import { Outlet } from '@tanstack/react-router'
import { Toaster } from 'sonner'
import { AuthProvider } from './components/AuthProvider'
import { AppShell } from './components/layout/AppShell'

export default function App() {
  return (
    <AuthProvider>
      <AppShell>
        <Outlet />
      </AppShell>
      <Toaster position="bottom-right" richColors closeButton />
    </AuthProvider>
  )
}
